import { DatePipe, DecimalPipe } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { ExplorationService } from '../../main-layout/explorations/exploration.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { RestService } from './rest.service';
import { AuthService } from '../../auth/auth.service';
import { Base64FileFormats, ThemeConfig, TokenPropertyUrl, UnitMeasurement } from '../../../appconfig';
import { environment } from '../../../environments/environment';
import { formatDate } from '@angular/common';
import { menuList } from '../../left-nav/menu';
import { JwtService } from '../../auth/jwtservice';
const userAgent: string = navigator.userAgent;


const isMobileDevice = (): boolean => {
  const regexs = [
    /(Android)(.+)(Mobile)/i,
    /BlackBerry/i,
    /iPhone|iPod/i,
    /Opera Mini/i,
    /IEMobile/i,
  ];
  return regexs.some((b) => userAgent.match(b));
};

const isTabletDevice = (): boolean => {
  const regex =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/;
  return regex.test(userAgent.toLowerCase());
};

const isDesktopDevice = (): boolean => !isMobileDevice() && !isTabletDevice();
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  nameInitial: string = '';
  relationInitial: string = '';
  selectedTab: number = 0;
  address: string = '';
  dummyDataUrl: string = '../../../assets/dummydb/';
  public isMobileDevice: boolean = isMobileDevice();
  public userProfile = new BehaviorSubject<any>(null);
  public actionType = new BehaviorSubject<any>(null);
  currentUserName: any;

  /**
   * Converts area from one unit to another.
   * @param area Area value
   * @param fromUnit Source unit (e.g. UnitMeasurement.SqMeter)
   * @param toUnit Target unit (e.g. UnitMeasurement.Biswa)
   * @returns Converted area
   */
  public convertArea(area: number, fromUnit: UnitMeasurement, toUnit: UnitMeasurement): number {
    // Convert to Square Meters first (Base Unit)
    let areaInSqMeters = area;
    switch (fromUnit) {
      case UnitMeasurement.Hectare: areaInSqMeters = area * 10000; break;
      case UnitMeasurement.Acre: areaInSqMeters = area * 4046.8564224; break;
      case UnitMeasurement.Beegha: areaInSqMeters = area * 2529.285264; break;
      case UnitMeasurement.Biswa: areaInSqMeters = area * 126.4642632; break; // 1/20th of a Beegha
      case UnitMeasurement.SqMeter: areaInSqMeters = area; break;
      case UnitMeasurement.SqYards: areaInSqMeters = area * 0.83612736; break;
      case UnitMeasurement.SqFeet: areaInSqMeters = area * 0.09290304; break;
      case UnitMeasurement.Naali: areaInSqMeters = area * 200; break; // Approx for Uttarakhand
      default: areaInSqMeters = area; break;
    }

    // Convert from Square Meters to Target Unit
    let finalArea = areaInSqMeters;
    switch (toUnit) {
      case UnitMeasurement.Hectare: finalArea = areaInSqMeters / 10000; break;
      case UnitMeasurement.Acre: finalArea = areaInSqMeters / 4046.8564224; break;
      case UnitMeasurement.Beegha: finalArea = areaInSqMeters / 2529.285264; break;
      case UnitMeasurement.Biswa: finalArea = areaInSqMeters / 125.4233064; break;
      case UnitMeasurement.SqMeter: finalArea = areaInSqMeters; break;
      case UnitMeasurement.SqYards: finalArea = areaInSqMeters / 0.83612736; break;
      case UnitMeasurement.SqFeet: finalArea = areaInSqMeters / 0.09290304; break;
      case UnitMeasurement.Naali: finalArea = areaInSqMeters / 200; break;
      default: finalArea = areaInSqMeters; break;
    }

    return Number(finalArea.toFixed(2));
  }

  constructor(
    private restService: RestService,
    private authService: AuthService,
    private jwtService: JwtService,
    private decimalPipe: DecimalPipe,
    private injector: Injector
  ) {
    if (isDesktopDevice()) {
      this.isHidden = false;
    }
    if (isMobileDevice() || isTabletDevice()) {
      this.isHidden = true;
    }
  }

  public isHidden: boolean = false;
  public siteId = new BehaviorSubject<any>(null);
  public selectedOption = new BehaviorSubject<any>(null);
  public showSiteModal = new BehaviorSubject<any>(false);
  public showUserProfileModal = new BehaviorSubject<any>(false);


  public refreshProject = new BehaviorSubject<any>(null);
  public refreshExploration = new BehaviorSubject<any>(null);
  private selectedProjectsSubject = new BehaviorSubject<any>(null);
  public selectedProjects$ = this.selectedProjectsSubject.asObservable();
  private selectedExplorationsSubject = new BehaviorSubject<any>(null);
  public selectedExplorations$ = this.selectedExplorationsSubject.asObservable();
  private selectedBookingId: any;
  public localStorageSiteId: any = localStorage.getItem('siteId');


  //#region  SITE AND PROJECTS
  /**
   * Gets the current site Id from local storage
   */
  getCurrentSiteId() {
    // First read current site id from local storage
    var selectedSiteId = this.getValueFromLocalStorage("siteId")
    //if we found the current site id then retrurn it
    if (selectedSiteId) return selectedSiteId

    //if selected site is not available then  we need to get it selected from userSites (all sites of uers)
    //here we need to check if usersSite available in local storage or not. if available then read from local storage
    //otherwise get user's sites from API based on current logged in userId
    var userSites: any = this.getValueFromLocalStorage("userSites")


    //check if user sites are available or not in local storage. If not then get it from API
    if (userSites) {
      userSites = JSON.parse(userSites)
      if (userSites.length > 1) {
        this.openSiteModal();
      }
      else {
        //if there is only one site in userSites list then that will be set as default siteId
        this.setLocalStorageValue("siteId", userSites[0]?.siteId)
      }
    }
    else {
      this.getUserSitesFromAPI(this.getLoggedInUserId())
    }

    //by now user must have selected the current site id from modal
    var selectedSiteId = this.getValueFromLocalStorage("siteId")
    return selectedSiteId
  }


  private isFetchingSites = false;

  /**
   * getting sites on behalf of userId from API
   * @param userId on behalf of which sites has to be fetched
   */
  getUserSitesFromAPI(userId: any) {
    if (userId && !this.isFetchingSites) {
      this.isFetchingSites = true;
      //here we setting values in local storage because here we getting data from api and we need to wait to receive the data
      this.restService.getData('site?userId=' + userId).subscribe(
        (data: any) => {
          this.isFetchingSites = false;
          localStorage.setItem('userSites', JSON.stringify(data?.result));
          if (data?.result?.length > 1) {
            //if there are multiple sites then show the modal so that user can select
            this.openSiteModal()
          } else {
            //if there is only one site then setjson stringify it and set in localstorage
            this.setLocalStorageValue('siteId', data?.result[0]?.siteId)
          }
        },
        (error: any) => {
          this.isFetchingSites = false;
        }
      );
    }
  }

  /**
   * Gets users Project List by Site Id from API
   * @param siteId Site Id for which project list ahs to be fetched
   */
  getUserPojectListBySiteId(siteId: any) {
    //First get user project list from Local storage and return if found.
    var userProjetList;
    userProjetList = this.getValueFromLocalStorage("userProjects")
    if (userProjetList) {
      userProjetList = userProjetList.replaceAll("projectId", "id")
      userProjetList = JSON.parse(userProjetList)
      var selectedSiteProjects = userProjetList.filter((x: any) => x.siteId == siteId)
      return (selectedSiteProjects != null) ? selectedSiteProjects : null
    }
  }

  getUserExplorationListBySiteId(siteId: any) {
    let userExplorationList: any = this.getValueFromLocalStorage('userExplorations');
    if (userExplorationList) {
      userExplorationList = JSON.parse(userExplorationList);
      const selectedSiteExplorations = userExplorationList.filter((x: any) => (x.siteId ?? x.SiteId) == siteId);
      return selectedSiteExplorations != null ? selectedSiteExplorations : null;
    }
    return null;
  }



  syncSelectionsBySite(siteId: any, emitRefreshEvents: boolean = true) {
    if (!siteId) {
      return;
    }

    this.setLocalStorageValue('siteId', siteId);

    const siteExplorations = this.getUserExplorationListBySiteId(siteId) || [];
    const selectedExploration = siteExplorations.length > 0 ? siteExplorations[0] : null;

    if (selectedExploration) {
      this.setLocalStorageValue('selectedExploration', JSON.stringify(selectedExploration));
      this.updateSelectedExplorations(selectedExploration);
    } else {
      localStorage.removeItem('selectedExploration');
      this.updateSelectedExplorations(null);
    }

    const selectedExplorationId = selectedExploration?.explorationId ?? selectedExploration?.id ?? selectedExploration?.ExplorationId;
    const siteProjects = this.getUserPojectListBySiteId(siteId) || [];
    const explorationProjects = selectedExplorationId
      ? this.injector.get(ExplorationService).getUserProjectListByExplorationId(selectedExplorationId)
      : [];
    const selectedProject = selectedExplorationId
      ? explorationProjects[0] || null
      : siteProjects[0] || null;

    if (selectedProject) {
      this.setLocalStorageValue('selectedProject', JSON.stringify(selectedProject));
      this.updateSelectedProjects(selectedProject);
    } else {
      localStorage.removeItem('selectedProject');
      this.updateSelectedProjects(null);
    }

    if (emitRefreshEvents) {
      this.refreshProject.next(true);
      this.refreshExploration.next(true);
    }
  }

  syncSelectionByExploration(exploration: any, siteId: any = null) {
    if (!exploration) {
      return;
    }

    this.setLocalStorageValue('selectedExploration', JSON.stringify(exploration));

    const explorationId = exploration.explorationId ?? exploration.id ?? exploration.ExplorationId;
    if (!explorationId) {
      return;
    }

    const explorationProjects = this.injector.get(ExplorationService).getUserProjectListByExplorationId(explorationId);

    if (explorationProjects.length > 0) {
      this.setLocalStorageValue('selectedProject', JSON.stringify(explorationProjects[0]));
      this.updateSelectedProjects(explorationProjects[0]);
    } else {
      localStorage.removeItem('selectedProject');
      this.updateSelectedProjects(null);
    }
  }

  /**
   * Gets the selected site name based on current siteId
   * Reads from userSites in localStorage (not userProjects) for immediate availability
   * @returns siteName of the currently selected site
   */
  getSelectedSiteName(): any {
    // Only get siteId from localStorage, don't call getCurrentSiteId() which can trigger modal/auto-set
    const currentSiteId = this.getValueFromLocalStorage('siteId');

    // If no siteId selected yet, return empty string
    if (!currentSiteId) {
      return '';
    }

    // First try to get siteName from userSites (which is always cached)
    const userSitesStr = this.getValueFromLocalStorage('userSites');
    if (userSitesStr) {
      try {
        const userSites = JSON.parse(userSitesStr);
        const selectedSite = userSites.find((site: any) => site.siteId == currentSiteId || site.id == currentSiteId);
        if (selectedSite?.siteName) {
          return selectedSite.siteName;
        }
      } catch (e) {
        console.error('Error parsing userSites:', e);
      }
    }

    // Fallback: try to get from userProjects if userSites doesn't work
    const userProjects = this.getUserPojectListBySiteId(currentSiteId);
    if (userProjects?.[0]?.siteName) {
      return userProjects[0].siteName;
    }

    return '';
  }

  /**
   * return selected proejctId from localstorage
   * @returns curent selected project
   */
  getProjectFromLocalStorage(): any {
    let projectData: any;
    let project: any;
    //Read project information from local storage
    projectData = localStorage.getItem('selectedProject');
    if (projectData) {
      //parse the project information into json format
      project = JSON.parse(projectData);
      return project;
    } else {
      //refil project information based on user site. Emit this to subheader projectList()
      return this.setUserProjects();

      // return this.getProjectFromLocalStorage();
    }
  }

  /**
   * getting user project on behalf of siteId and userId
   * @param siteId getting projects on behalf of siteId comes from local storage
   * @param userId getting projects on behalf of userId comes from userToken
   * @returns
   */
  getUserProjectsFromAPI(siteId: any, userId: any) {
    var userProjects;

    if (!siteId) {
      return;
    }

    this.restService.getData('project/?userId=' + userId)
      .subscribe((data: any) => {
        if (data?.result) {
          localStorage.setItem('userProjects', JSON.stringify(data?.result));
          userProjects = data?.result.filter((x: any) => x?.siteId == this.getCurrentSiteId())
          if (userProjects) {
            // localStorage.setItem('selectedProject', JSON.stringify(userProjects[0]))
            this.selectedProjectsSubject.next(userProjects[0]);
            return userProjects;
          }
        }
      });
  }

  //Sets the user project list
  setUserProjects() {
    // if (!this.isProjectApiCalled) {
    const userProjects = this.getUserProjectsFromAPI(
      this.getCurrentSiteId(),
      this.getValueFromLocalStorage("userId")
    );
    this.setLocalStorageValue("selectedProject", userProjects)
    // }
  }

  //#endregion

  /**
   * defined the selected booking Id
   * @param bookingId
   */
  setSelectedBookingId(bookingId: any) {
    this.selectedBookingId = bookingId;
  }

  /**
   *
   * @returns exporting the selected row ID of the grid
   */
  getSelectedRowId(): any {
    return this.selectedBookingId;
  }

  /**
   * converting image type string to base64
   * @param normalString
   * @returns
   */
  BaseStringToNormalString(normalString: any, fileExt: any = null) {
    if (normalString) {
      if (fileExt?.toLowerCase() == 'pdf')
        return Base64FileFormats.PDF + normalString;
      else
        return Base64FileFormats.JPEG + normalString
    }
    else return null;
  }

  /**
   * method is used convert base64 to normal string
   * @param baseString
   * @returns
   */
  normalStringToBaseString(baseString: string) {
    if (baseString)
      return baseString.replace(/^data:image\/(jpeg|png|jpg);base64,/, '').replace(/^data:application\/(pdf);base64,/, '')
    else return null;
  }

  /**
 * Converts a base64 string to a Blob object
 * @param base64 base64 encoded string
 * @param mime mime type of the file (e.g., 'image/png', 'video/mp4')
 * @returns returns a Blob object created from the base64 string
 */
  base64ToBlob(base64: string, mime: string): Blob {
    if (base64 != null && mime != null && base64 != undefined && mime != undefined) {
      const byteChars = atob(base64);
      const byteNumbers = new Array(byteChars.length).fill(0).map((_, i) => byteChars.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mime });
    }
    else return new Blob();
  }

  getFileTypeFromBase64String(baseString: string) {
    if (baseString) {
      var format = baseString.substring("data:".length, baseString.indexOf(";base64"));
      format = format.includes("/") ? format.split("/")[1] : format;
      return format;
    }
    return null;
  }

  /**
   * returning the expected date format for exported file name and transactionId
   * @returns
   */
  getCurrentTimeStamp() {
    let pipe = new DatePipe('en-US');
    return pipe.transform(new Date(), 'MMddyyyyHHmmss');
  }

  /**
   * common search function for grid
   * @param gridApi
   * @param field
   */
  getCurrentTimeStampClient() {
    let pipe = new DatePipe('en-US');
    return pipe.transform(new Date(), 'MMddyyyyHHmm');
  }

  /**
   * common search function for grid
   * @param gridApi
   * @param field
   */
  searchText(gridApi: any, field: any) {
    gridApi.setGridOption('quickFilterText', field);
  }

  /**
   * Getting Initials
   */
  initialState() {
    this.restService.getData('name-initial?type=name').subscribe((res) => {
      this.nameInitial = res.result.name;
    });
  }

  /**
   * opening site modal while click Switch Site from profile dropdown
   */
  openSiteModal() {
    this.showSiteModal.next(true)
  }

  /**
   * Gets Current Logged in user
   */
  getLoggedInUserId() {
    var currentUserId = null;
    //First check id current user id available in local storage or not if not then checck if user is logged in or not
    currentUserId = this.getValueFromLocalStorage("userId")
    if (currentUserId) return currentUserId

    this.authService.loggedIn()
    return currentUserId
  }


  /**
   * Gets Current Logged in user
   */
  getLoggedInUserName() {
    this.currentUserName = this.jwtService.getUserPropertyValueFromToken(TokenPropertyUrl.userName).replace(/(\d{5})(\d{5})/, '$1-$2');

    if (this.currentUserName) return this.currentUserName

    this.authService.loggedIn()
    return this.currentUserName
  }

  /**
   * Gets userId from token which  was stored in local storage after userlogin
   * @returns returns user id
   */
  getValueFromLocalStorage(key: any) {
    return localStorage.getItem(key);
  }

  /**
   * Sets value of a key in local storage
   * @param key key against which value has to be set
   * @param value values which has to be set in local storage
   */
  setLocalStorageValue(key: any, value: any) {
    localStorage.setItem(key, value)
  }

  /**
   * Method to set the selected tab index
   * @param index index of selected tab which is to be set
   */
  selectTab(index: number): void {
    this.selectedTab = index;
  }

  /**
   * Method to check if a tab is selected
   * @param index index of selected tab which is to be check is it selected or not
   * @returns
   */
  isTabSelected(index: number): boolean {
    return this.selectedTab === index;
  }

  /**
   * sets the dummy data url conditionally i.e. if API is working then data will come from actual api url else it will use dummy url for getting dummmy data
   * @param apiUrl actual api url
   * @param dummydataUrl dummy data url
   * @returns returns api url for data
   */
  setDataUrl(apiUrl: string, dummydataUrl: string) {
    if (environment.isDummyDataSource) return dummydataUrl
    else return apiUrl
  }

  /**
  * Gets the current user profile data
  */
  getUserProfile() {
    return this.userProfile.asObservable();
  }

  /**
   * Sets current selected booking object so that it can be subscribed in any component.
   * Right now using to show document of a particular booking
   * @param selectedBooking currently selected booking
   */
  setUserProfile(updatedData: any) {
    this.userProfile.next(updatedData);
  }

  //getting gender from dummy data
  getGenders(): any {
    return {
      'result': [{ 'name': 'Male' }, { 'name': 'Female' }]
    }
  }

  addSpaceInCamelCase(value: string) {
    var val = value.replace(/([A-Z])/g, ' $1').trim()
    val = val.slice(0, 1).toUpperCase() + val.slice(1);
    return val;
  }

  /**
   * put method to update user address
   * @param id userId on which behalf updating user's address
   * @param data payload
   * @returns
   */
  addressupdate(id: any, data: any) {
    return this.restService.updateData('user/addresses', id, data);
  }

  /**
   * Formats the address comma and hyphen puncuations (removes extra commas)
   * @param address Address to be formatted
   */
  formateAddress(address: string): string {
    // Replace the double comma with single comma in case if any part of address is missing like Address 2
    address = address.replace(",,", ",").replace(",-", "-")

    //If Pin number in address is not available then remove the hyphen in last from address field
    if (address.substring(address.length - 1, address.length) == "-")
      address = address.substring(0, address.length - 1)

    return address;
  }

  /**
   * Gets List of unique values objects from a json aray
   * @param arrayList Json array object from which quniue item list has to be filter
   * @param uniqueFieldToFind Key which has to be filtered uniquely
   */
  getUniqueValuesFromJsonArray(arrayList: any[], uniqueFieldToFind: any) {
    let uniqueSites: any[] = [];

    arrayList.forEach((currRecord: any) => {
      let isExists: boolean = false

      uniqueSites.forEach(uniquesite => {
        if (currRecord[uniqueFieldToFind] == uniquesite[uniqueFieldToFind])
          isExists = true;
      })
      if (!isExists) uniqueSites.push(currRecord)
    });

    return uniqueSites;
  }

  /**
   * Gets First and last name of user from it's full name
   * @param name Full Name which has to be break into frist name and last name
   * @returns First and Last Name
   */
  getUsersFirstLastName(name: string): { firstName: string; lastName: string } {
    const words = name?.trim().split(" ");
    let firstName = "";
    let lastName = "";

    if (words.length === 1) {
      // If there's only one word, set it as the first name
      firstName = words[0];
    } else if (words.length === 2) {
      // If there are two words, split them into first and last name
      firstName = words[0];
      lastName = words[1];
    } else {
      // If there are more than two words, combine the first two as firstName and the rest as lastName
      firstName = words.slice(0, 2).join(" ");
      lastName = words.slice(2).join(" ");
    }

    return { firstName, lastName };
  }

  setActionType(value: any) {
    this.actionType.next(value);
  }

  getActionType() {
    return this.actionType.asObservable();
  }

  dateTimeFormate(date: Date, dateOnly: boolean = false): string {
    if (dateOnly) {
      return formatDate(date, 'dd-MMM-yyyy', 'en-IN');
    }
    return formatDate(date, 'yyyy-MM-ddTHH:mm:ss', 'en-IN');
  }

  isNullUndefined(input: any): boolean {
    return input === "" || input === null || input === undefined;
  }

  /**
   * Updates the selectedProjects Observable with a new value
   * @param value The selected project to emit
   */
  updateSelectedProjects(value: any): void {
    this.selectedProjectsSubject.next(value);
  }

  /**
   * Updates the selectedExplorations Observable with a new value
   * @param value The selected exploration to emit
   */
  updateSelectedExplorations(value: any): void {
    this.selectedExplorationsSubject.next(value);
  }

  getLocations(searchingFor: string, searchingBy: string, searchingById: any) {
    return this.restService.getData('Location/' + searchingFor + '?' + searchingBy + 'Id=' + searchingById, false);
  }

  /**
   * Searchs a record in json data array for specific value in specific field
   * @param data JSON data in which record has to be searched
   * @param searchField field of json data wholse value has to be searched
   * @param searchValue value has to be searched in json data
   * @returns
   */
  searchRecordInJSONData(data: any, searchField: string, searchValue: string) {
    if (data) {
      for (var index = 0; index < data.length; index++) {
        if (data[index][searchField] == searchValue)
          return data[index]
      }
    }
    else
      return null;
  }

  /**
   * Gets the User Full name along with name initials from a user object
   * @param userObject user object from which user name has to be fetched
   * @returns Returns full Name of user with name initials
   */
  getUserNameFromObject(userObject: any) {
    if (userObject) {
      return (userObject?.nameInitial?.name + '.' + userObject.firstName + ' ' + userObject?.lastName)
    }
    return null
  }

  /**
   * Formate any number to decimal 2 points
   */
  formatToTwoDecimal(value: any): number {
    if (isNaN(value) || value == null) {
      return 0.00; // Return a number instead of a string
    }

    var val = parseFloat(parseFloat(value).toFixed(2));

    return val
  }

  getFirstAccessibleSubMenu(userRoles: string[]): string | null {
    // Recursive helper function
    const findAccessibleMenu = (menus: any[]): string | null => {
      for (const menu of menus) {
        const hasAccess = !menu.role || menu.role.some((r: string) => userRoles.includes(r));

        // If current menu has a URL and user has access, return it
        if (hasAccess && menu.url && menu.url.length > 0) {
          return menu.url[0];
        }

        // Otherwise, check submenus recursively
        if (menu.subMenu && menu.subMenu.length > 0) {
          const subUrl = findAccessibleMenu(menu.subMenu);
          if (subUrl) return subUrl;
        }
      }
      return null;
    };

    // Start searching from the top-level menu list
    return findAccessibleMenu(menuList);
  }

  formatIndianCurrency(amount: number | string): string {
    const x = amount.toString().split('.');
    let integerPart = x[0];
    const decimalPart = x[1] ? '.' + x[1] : '';

    const lastThree = integerPart.slice(-3);
    const otherNumbers = integerPart.slice(0, -3);

    const formatted = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");

    return (otherNumbers ? formatted + ',' + lastThree : lastThree) + decimalPart;
  }

  // Mask Aadhaar Card Number: XXXX-XXXX-1234
  maskAadhaarNumber(aadhaarNumber: string): string {
    if (!aadhaarNumber || aadhaarNumber.length !== 12) return '';
    return `XXXX-XXXX-${aadhaarNumber.slice(-4)}`;
  }

  // Mask PAN Card Number: XXXXXX123K
  maskPanNumber(panNumber: string): string {
    if (!panNumber || panNumber.length !== 10) return '';
    return `XXXXXX${panNumber.slice(-4)}`;
  }

  // Format Indian phone number like 98765-43210
  formatPhoneNumberWithHyphen(phoneNumber: string): string {
    if (!phoneNumber || phoneNumber.length !== 10) return phoneNumber;
    return `${phoneNumber.slice(0, 5)}-${phoneNumber.slice(5)}`;
  }

  getOrganisationLogo(orgId: any) {
    const folderPath = `Organization/${orgId}/Logo`
    return this.restService.getData('document-processor/store/download-byte-from?folderPath=' + folderPath);
  }


  getDistinctValuesFromArray(array: any[], key: string): any[] {
    const uniqueValues = new Set();
    const distinctArray: any[] = [];

    array.forEach(item => {
      if (item[key] && !uniqueValues.has(item[key])) {
        uniqueValues.add(item[key]);
        distinctArray.push(item);
      }
    });

    return distinctArray;
  }


  /**
   * This method return the unique value of a key in an array object
   * @param array Array from which distinct value has to be fetched
   * @param key key for which distinct values have to be fetched
   * @returns 
   */
  getDistinctKeyValueFromArray(array: any[], key: string): any[] {
    const uniqueValues = new Set();
    const distinctArray: any[] = [];

    array.forEach(item => {
      if (item[key] && !uniqueValues.has(item[key])) {
        uniqueValues.add(item[key]);
        distinctArray.push(item[key]);
      }
    });

    return distinctArray;
  }


  /**
   * This method is to generally return the config to show/hide location dropdowns on address details popup
   * @param showState flag to show/hide state dropdown
   * @param showDistrict flag to show/hide district dropdown
   * @param showCity flag to show/hide city dropdown
   * @param showTehsil flag to show/hide tehsil dropdown
   * @param showVillage flag to show/hide village dropdown
   * @returns 
   */
  setLocationFieldToShowOnAddressDetail(showState: boolean = false, showDistrict: boolean = false, showCity: boolean = false,
    showTehsil: boolean = false, showVillage: boolean = false) {
    return {
      "showState": showState,
      "showDistrict": showDistrict,
      "showCity": showCity,
      "showTehsil": showTehsil,
      "showVillage": showVillage
    }
  }

  /**
   * Fetch the index of an object in an array by its value of a specific field
   * @param araay 
   * @param fieldNmae 
   * @param fieldValue 
   */
  getObjectIndexInArrayByFieldValue(objArr: any[], fieldNmae: any, fieldValue: any) {
    for (var index = 0; index < objArr.length; index++) {
      if (objArr[index][fieldNmae] == fieldValue)
        return index;
    }
    return null;
  }

  toDateOnly(date: Date): any {
    if (!date) return null;

    const dt = new Date(date);

    const year = dt.getFullYear();
    const month = String(dt.getMonth() + 1).padStart(2, '0');
    const day = String(dt.getDate()).padStart(2, '0');

    return new Date(`${year}-${month}-${day}`);
  }

  /**
   * Convert UTC timestamp to local timezone Date object
   * This method takes a UTC timestamp from API and converts it to a Date object
   * that displays in the user's local timezone when formatted
   * @param utcTimestamp - The UTC timestamp (either in seconds or milliseconds)
   * @param isUnixTime - If true, multiplies by 1000 to convert seconds to milliseconds
   * @returns Date object adjusted for local timezone
   */
  convertUtcToLocalTimezone(utcTimestamp: any, isUnixTime: boolean = false): Date {
    if (!utcTimestamp) return new Date();

    // Convert to milliseconds if it's Unix time (seconds)
    const milliseconds = isUnixTime ? utcTimestamp * 1000 : utcTimestamp;

    // Create a Date object from the UTC timestamp
    const utcDate = new Date(milliseconds);

    // Get the timezone offset in milliseconds
    const timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;

    // Adjust the date by adding the timezone offset to convert UTC to local time
    const localDate = new Date(utcDate.getTime() + timezoneOffset);

    return localDate;
  }

  /**
   * Convert GMT/ISO timestamp string to local timezone
   * Backend sends timestamps in GMT format (e.g., "2026-04-23T10:00:00" representing 10 AM GMT)
   * This method properly interprets them as GMT and converts to local timezone display
   * @param gmtTimestamp - Timestamp in GMT format (ISO string like "2026-04-23T10:00:00" or milliseconds)
   * @param isUnixTime - If true, multiplies by 1000 to convert seconds to milliseconds
   * @returns Date object in local timezone
   */
  convertGmtToLocalTimezone(gmtTimestamp: any, isUnixTime: boolean = false): Date {
    if (!gmtTimestamp) return new Date();

    let dateObj: Date;

    // Handle string timestamps (ISO format from backend)
    if (typeof gmtTimestamp === 'string') {
      // If the string doesn't have Z suffix, append it to indicate GMT/UTC
      // This tells JavaScript to parse it as UTC, not local time
      const isoString = gmtTimestamp.includes('Z') || gmtTimestamp.includes('+')
        ? gmtTimestamp
        : gmtTimestamp + 'Z';
      dateObj = new Date(isoString);
    } else {
      // Handle numeric timestamps (milliseconds or unix seconds)
      const milliseconds = isUnixTime ? gmtTimestamp * 1000 : gmtTimestamp;
      dateObj = new Date(milliseconds);
    }

    // JavaScript Date object automatically converts to local timezone
    // No need for manual offset adjustment since we've told it to parse as UTC
    return dateObj;
  }

  /**
   * Convert file extension to MIME type
   * @param ext - File extension (e.g., 'pdf', 'jpg', 'docx')
   * @returns MIME type (e.g., 'application/pdf', 'image/jpeg')
   */
  getMimeTypeFromExtension(ext: string): string {
    if (!ext) return '';

    const extension = ext.toLowerCase().replace('.', '');
    const mimeTypeMap: { [key: string]: string } = {
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'txt': 'text/plain',
      'dwg': 'application/acad',
      'dxf': 'application/dxf',
      'cad': 'application/cad'
    };

    return mimeTypeMap[extension] || '';
  }

  /**
   * Get FontAwesome icon class based on file extension
   * Universal method for documents and reports across the entire app
   * @param fileExtn - File extension (e.g., 'pdf', 'jpg', 'docx', 'xlsx')
   * @returns FontAwesome icon class (e.g., 'fa-file-pdf', 'fa-file-image')
   */
  getFileIcon(fileExtn: string): string {
    if (!fileExtn) return 'fa-file';

    const extn = fileExtn.toLowerCase().trim();

    const iconMap: { [key: string]: string } = {
      'pdf': 'fa-file-pdf',
      'doc': 'fa-file-word',
      'docx': 'fa-file-word',
      'xls': 'fa-file-excel',
      'xlsx': 'fa-file-excel',
      'ppt': 'fa-file-powerpoint',
      'pptx': 'fa-file-powerpoint',
      'jpg': 'fa-file-image',
      'image': 'fa-file-image',
      'jpeg': 'fa-file-image',
      'png': 'fa-file-image',
      'gif': 'fa-file-image',
      'zip': 'fa-file-archive',
      'rar': 'fa-file-archive',
      'txt': 'fa-file-alt',
      'csv': 'fa-file-csv',
      'json': 'fa-file-code'
    };

    return iconMap[extn] || 'fa-file';
  }

  /**
    * Check if user has access to the project
    */
  hasProjectAccess(projectId: string): boolean {
    const userProjectsJson = localStorage.getItem('userProjects');
    if (!userProjectsJson) {
      return false;
    }
    try {
      const userProjects = JSON.parse(userProjectsJson);
      const projectIdNum = parseInt(projectId, 10);
      // Check if projectId exists in userProjects
      const hasAccess = userProjects.some((project: any) =>
        project.projectId === projectIdNum || project.id === projectIdNum
      );
      return hasAccess;
    } catch (error) {
      console.error('Error checking project access:', error);
      return false;
    }
  }

  /**
   * Check if user has access to the exploration
   */
  hasExplorationAccess(explorationId: string): boolean {
    const userExplorationsJson = localStorage.getItem('userExplorations');
    if (!userExplorationsJson) {
      return false;
    }
    try {
      const userExplorations = JSON.parse(userExplorationsJson);
      const explorationIdNum = parseInt(explorationId, 10);
      // Check if explorationId exists in userExplorations
      const hasAccess = userExplorations.some((exploration: any) =>
        exploration.explorationId === explorationIdNum || exploration.id === explorationIdNum
      );
      return hasAccess;
    } catch (error) {
      console.error('Error checking exploration access:', error);
      return false;
    }
  }

  /**
   * Detect file type from base64 content
   */
  detectFileTypeFromBase64(base64Data: string): string {
    // Check for PDF magic number
    if (base64Data.includes('JVBERi0')) {
      return 'application/pdf';
    }
    // Check for JPEG magic number
    if (base64Data.startsWith('/9j/')) {
      return 'image/jpeg';
    }
    // Check for PNG magic number
    if (base64Data.startsWith('iVBORw0')) {
      return 'image/png';
    }
    // Check for GIF magic number
    if (base64Data.startsWith('R0lGODlh')) {
      return 'image/gif';
    }
    // Default to PDF as most documents are PDFs
    return 'application/pdf';
  }

  /**
 * Returns file category (image, video, audio, pdf, doc, etc.) based on extension
 * @param ext File extension (e.g., 'pdf', 'jpg', 'mp4')
 * @returns Category string (e.g., 'image', 'video', 'audio', 'pdf', 'doc', 'other')
 */
  getFileCategoryByExtension(ext: string): string {
    if (!ext) return 'other';
    const extension = ext.toLowerCase().replace('.', '');
    if ([
      'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'ico'
    ].includes(extension)) return 'image';
    if ([
      'mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'mpeg', 'mpg'
    ].includes(extension)) return 'video';
    if ([
      'mp3', 'wav', 'aac', 'm4a', 'ogg', 'wma', 'flac', 'amr'
    ].includes(extension)) return 'audio';
    if (extension === 'pdf') return 'pdf';
    if ([
      'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'json', 'xml', 'rtf'
    ].includes(extension)) return 'doc';
    if ([
      'dwg', 'dxf', 'cad'
    ].includes(extension)) return 'cad';
    return 'other';
  }

  /**
   * Converts a GMT/UTC datetime string to a Date object in the user's local timezone
   * When API returns dates in GMT format (e.g., "2024-05-07T18:30:00Z"), 
   * this method converts them to the user's local timezone
   * @param gmtDateTime ISO format datetime string from API (in GMT/UTC) or Date object
   * @returns Date object representing the datetime in the user's local timezone
   * @example
   * // API returns: "2024-05-07T18:30:00Z" (which is May 8, 00:00 in GMT+5:30)
   * const localDate = this.convertToLocalTimeZone("2024-05-07T18:30:00Z");
   * // localDate will represent May 8, 00:00 in user's local timezone
   */
  convertToLocalTimeZone(gmtDateTime: string | Date): Date {
    // Handle both string (from API) and Date objects
    if (typeof gmtDateTime === 'string') {
      // Parse the ISO datetime string - JavaScript automatically converts from UTC to local timezone
      return new Date(gmtDateTime);
    }
    // If already a Date object, return as-is
    return gmtDateTime;
  }
}
